import styles from "./Modal.module.css"
import { useEffect } from "react"
import { RiCloseFill } from "react-icons/ri";


const Modal = (props) => {
    // THE ONCLOSE FUNCTION IS COMING FROM WHEREVER WE ARE CALLING THE MODAL FROM
    const { onClose, title, content, actionButton, noHeader, noBackground } = props;
  
    // THIS ALLOWS THE USER TO CLOSE MODAL BY HITTING THE ESCAPE KEY
  
    function closeOnEscapeKeyDown(e) {
      if ((e.charCode || e.keyCode) === 27) onClose();
    }
  
    useEffect(() => {
      document.body.addEventListener("keydown", closeOnEscapeKeyDown);
      return function cleanUp() {
        document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
      };
    });
  
    // THIS IS THE MODAL THAT WILL BE SHOWING UP(CHANGE MODAL CONTENTS AND CLASSNAMES HERE)
    const modal = (
      <div className={styles.outside_modal} onClick={onClose}>
        <div className={`${styles.modal} ${noBackground ? styles.no_background_modal : null}`  } onClick={(e) => e.stopPropagation()}>
          {
            !noHeader && (
                <header className={styles.modal_header}>
                    <div>{ ""}</div>
                    <h2>{ title}</h2>
            <span onClick={onClose} className={styles.close_button}>
            <RiCloseFill  size={27} />{" "}

            </span>
          </header>

            )
          }
  
          <section className={`${styles.modal_content} `}>
            <h1> {content} </h1>
          </section>
          <footer className={styles.modal_footer}>
                    <h3>{ actionButton}</h3>
          </footer>
        </div>
      </div>
    );
  
    return <>{modal}</>;
  };
  
  export default Modal;
  